import React from 'react';
import styled from 'styled-components';

interface TooltipPopupProps {
  content: React.ReactNode;
  placement: 'top' | 'bottom' | 'left' | 'right';
}

interface StyledContainerProps {
  children?: React.ReactNode;
}

const TooltipContainer = styled.div<StyledContainerProps>`
  background: #1C1C1C;
  color: white;
  padding: 12px 16px;
  border-radius: 8px;
  font-size: 14px;
  max-width: 300px;
  word-wrap: break-word;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  line-height: 1.5;

  h3 {
    margin: 0 0 8px 0;
    font-size: 14px;
    display: flex;
    align-items: center;
  }

  br {
    content: "";
    display: block;
    margin: 8px 0;
  }

  b {
    font-weight: 700;
  }
`;

const TooltipPopup: React.FC<TooltipPopupProps> = ({ content, placement }) => {
  // Use type assertion to help TypeScript understand the content type
  const safeContent = content as React.ReactNode & string;
  
  return (
    <TooltipContainer>
      {safeContent}
    </TooltipContainer>
  );
};

export default TooltipPopup; 